import type { RateCardSection } from "@/hooks/api/use-rate-card";

export const SECTIONS: { value: RateCardSection; label: string; note: string }[] = [
	{ value: "setup", label: "Campaign setup", note: "Per campaign, charged at approval" },
	{ value: "services", label: "Strategy and optimisation", note: "Per campaign" },
	{ value: "whatsapp", label: "WhatsApp lead management", note: "Optional add-on" },
	{ value: "usage", label: "Usage", note: "Billed monthly in arrears on actual talk time" },
	{ value: "additional", label: "Additional services", note: "Billed in 15-minute increments" },
];

/** "SGD 3,872 per campaign", "SGD 0.30 per minute", or the note that stands in for a price. */
export function formatPrice({
	amount,
	currency,
	unit,
	priceNote,
}: {
	amount: string | null;
	currency: string;
	unit: string | null;
	priceNote: string | null;
}): string {
	if (amount === null) return priceNote ?? "Price on request";
	const value = Number(amount);
	const figure = value.toLocaleString("en-SG", {
		minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
		maximumFractionDigits: 2,
	});
	return [`${currency} ${figure}`, unit].filter(Boolean).join(" ");
}
